export enum ConversionFormula {
  None = '',
  CelsiusToFahrenheit = 'c-to-f',
  FahrenheitToCelsius = 'f-to-c',
  KiloPascalToPSI = 'kpa-to-psi',
  PSIToKiloPascal = 'psi-to-kpa',
  LitersPerSecondToCFM = 'lps-to-cfm', // liters per second to cubic feet per minute
  CFMToLitersPerSecond = 'cfm-to-lps'  // cubic feet per minute to liters per second
}


export type TileSetPointConversion = ConversionFormula | '';


export const TILE_MAX_DECIMAL_PLACES = 6;

export type TileSetPointDecimal = 0 | 1 | 2 | 3 | 4 | 5 | 6;
export type TileSetPointIncrement = 10 | 5 | 1 | 0.1 | 0.5;
export type TileSetPointMultiplier = 0.0001 | 0.001 | 0.01 | 0.1 | 1 | 10 | 100 | 1000 | 10000;
